import PropTypes from 'prop-types';

const addressPropTypes = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
});

export default addressPropTypes;
